var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300px",
    height: "300px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.955
    },
    fill: "#ed3a94",
    d: "M 177.5,1.5 C 182.126,0.700387 185.96,2.03372 189,5.5C 189.667,101.5 189.667,197.5 189,293.5C 183.714,298.657 178.214,298.824 172.5,294C 138.5,267.667 104.5,241.333 70.5,215C 51.2564,213.691 31.923,213.024 12.5,213C 9.42651,212.261 7.25985,210.428 6,207.5C 5.01302,170.415 5.34635,133.415 7,96.5C 7.90252,95.2986 9.06919,94.4652 10.5,94C 27.1667,93.6667 43.8333,93.3333 60.5,93C 99.6863,62.6363 138.686,32.1363 177.5,1.5 Z M 171.5,28.5 C 172.666,108.999 172.832,189.666 172,270.5C 140.167,246 108.333,221.5 76.5,197C 58.5937,195.527 40.5937,195.027 22.5,195.5C 22.5,167.167 22.5,138.833 22.5,110.5C 38.2626,110.969 53.9292,110.469 69.5,109C 103.687,82.3029 137.687,55.4695 171.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.924
    },
    fill: "#ed3a94",
    d: "M 250.5,63.5 C 254.31,63.379 257.477,64.7124 260,67.5C 285.817,120.188 287.15,173.521 264,227.5C 259.867,231.9 255.2,232.567 250,229.5C 248.596,227.361 247.763,225.028 247.5,222.5C 253.112,207.163 257.612,191.496 261,175.5C 263.93,152.9 262.596,130.566 257,108.5C 252.909,96.4892 248.409,84.6558 243.5,73C 243.813,68.2062 246.146,65.0395 250.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.922
    },
    fill: "#ed3a94",
    d: "M 205.5,92.5 C 208.649,92.2114 211.649,92.7114 214.5,94C 241.08,127.917 243.246,163.417 221,200.5C 215.667,205.833 210.333,205.833 205,200.5C 204.333,197.833 204.333,195.167 205,192.5C 223.98,162.22 222.646,132.887 201,104.5C 199.474,99.2389 200.974,95.2389 205.5,92.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOn);
export default __webpack_public_path__ + "static/media/Sound_On.1b98cf688ffe5c054edb04f0596a9db4.svg";
export { ForwardRef as ReactComponent };